var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05879 21.8528C4.1323 21.5811 3.96983 21.2031 3.81477 20.9307C3.76649 20.8495 3.71411 20.7708 3.65785 20.6949C2.32795 18.669 1.61912 16.2957 1.6192 13.869C1.59758 6.90346 7.34782 1.25098 14.4584 1.25098C20.6596 1.25098 25.8359 5.5662 27.0455 11.2944C27.2268 12.1437 27.3183 13.0098 27.3186 13.8783C27.3186 20.8538 21.7901 26.595 14.6796 26.595C13.549 26.595 12.0231 26.3096 11.191 26.0756C10.3588 25.8417 9.52794 25.5314 9.31357 25.4482C9.09433 25.3636 8.86149 25.3201 8.62661 25.3198C8.37006 25.3188 8.11597 25.3701 7.87972 25.4706L3.68936 26.9897C3.59756 27.0294 3.50029 27.0549 3.40086 27.0654C3.3224 27.0651 3.24477 27.0493 3.17246 27.0187C3.10015 26.9881 3.03461 26.9434 2.97962 26.8872C2.92463 26.831 2.88129 26.7643 2.85212 26.6912C2.82294 26.618 2.80851 26.5398 2.80965 26.461C2.8148 26.3918 2.82723 26.3234 2.84672 26.2568L4.05879 21.8528Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/IconComment.d8a107c2fe5e31a8b9a4e9de79f0f7b1.svg";
export { ForwardRef as ReactComponent };